import Swiper from 'swiper/dist/js/swiper';

// Sliders
export const sliderFeaturesInit = () => {
	const $slider = $('.slider-features');

	$slider.each(function() {
		const $this = $(this);
		const items = $this.data('items');
		let $slides = $this.find('.swiper-container');
		const pagination = $this.find('.swiper-pagination');

		const features = new Swiper($slides, {
			slidesPerView: items,
			touchRatio: 0,
			pagination: {
				el: pagination
			},
			breakpoints: {
				767: {
					slidesPerView: 1,
					touchRatio: 1,
					loop: true,
				}
			}
		});
	});
}

export const sliderCommentsInit = () => {
	const comments = $('.slider-comments');

	comments.each(function() {
		const $this = $(this);
		let $slides = $this.find('.swiper-container');
		const pagination = $this.find('.swiper-pagination');

		const sliderComments = new Swiper($slides, {
			slidesPerView: 4,
			touchRatio: 0,
			pagination: {
				el: pagination
			},
			breakpoints: {
				767: {
					slidesPerView: 1,
					touchRatio: 1,
					loop: true,
					autoHeight	: true
				}
			}
		});
	});
}

export const sliderProductInit = () => {
	const $products = $('.slider-products');

	$products.each(function() {
		const $this = $(this);
		const $slides = $this.find('.swiper-container');
		const pagination = $this.find('.swiper-pagination');

		const sliderProducts = new Swiper($slides, {
			pagination: {
				el: pagination
			},
			direction: 'vertical',
			slidesPerView: 1
		});
	});
}

export const mainSliderInit = () => {
	const $mainSlider = $('.slider-main');

	$mainSlider.each(function() {
		const $this = $(this);
		const $slides = $this.find('.swiper-container');
		const pagination = $this.find('.swiper-pagination');

		const slider = new Swiper($slides, {
			loop: true,
			pagination: {
				el: pagination
			},
			slidesPerView: 1
		});
	});
}

export const sliderPartnersInit = () => {
	const $partners = $('.slider-partners');

	$partners.each(function() {
		const $this = $(this);
		const $slides = $this.find('.swiper-container');
		const pagination = $this.find('.swiper-pagination');

		const sliderPartners = new Swiper($slides, {
			slidesPerView: 3,
			touchRatio: 0,
			pagination: {
				el: pagination
			},
			breakpoints: {
				767: {
					slidesPerView: 1,
					touchRatio: 1,
					loop: true,
					autoHeight: true
				}
			}
		});
	});
}



// WEBPACK FOOTER //
// ../src/assets/js/sliders.js